import {
  PromotionOutboxDetail,
  PromotionOutboxRow,
  PromotionRegFunction
} from '@/common/model/promotionOutbox'

export const PromotionOutboxApiPath = {
  LIST_FUNCTIONS: '/api/promotion-outbox/functions', // GET 登録機能カタログ
  LIST: '/api/sites/{site_id}/promotion-outbox', // GET 一覧
  DETAIL: '/api/sites/{site_id}/promotion-outbox/{outbox_id}' // GET 詳細
} as const

export type PromotionOutboxApiPath =
  (typeof PromotionOutboxApiPath)[keyof typeof PromotionOutboxApiPath]

export interface ListRegFunctionsVars {}

export interface ListOutboxVars {
  site_id: number
  status?: string
  promotion_type?: string
}

export interface GetOutboxVars {
  site_id: number
  outbox_id: number
}

export interface RegFunctionsResponse {
  items: PromotionRegFunction[]
}

export interface OutboxListResponse {
  items: PromotionOutboxRow[]
  total: number
}

export type OutboxDetailResponse = PromotionOutboxDetail
